import { roundToDecimals } from "./numberUtils";

const DOLLAR_WEIGHT_DECIMALS = 6;

export function isValidNlv(nlv: number | null | undefined): nlv is number {
  return typeof nlv === "number" && Number.isFinite(nlv) && nlv > 0;
}

export function normalizeWholeDollars(value: number): number {
  if (!Number.isFinite(value) || value <= 0) return 0;
  return Math.round(value);
}

export function weightToWholeDollars(weight: number, nlv: number): number {
  if (!isValidNlv(nlv) || !Number.isFinite(weight) || weight <= 0) return 0;
  return roundToDecimals((weight / 100) * nlv, 0);
}

export function wholeDollarsToWeight(dollars: number, nlv: number): number {
  if (!isValidNlv(nlv)) return 0;
  const wholeDollars = normalizeWholeDollars(dollars);
  if (wholeDollars === 0) return 0;
  return roundToDecimals((wholeDollars / nlv) * 100, DOLLAR_WEIGHT_DECIMALS);
}
